/**
 * The upload session tells how to send the file: Azure Blob in the cloud (PUT),
 * the customer's FileService on-prem (POST). A session without a method, or
 * without a headers object (empty is fine), is malformed: fail instead of
 * guessing a method the storage would reject.
 */
export function assertUploadSession(session: {
  method?: unknown;
  headers?: unknown;
}): void {
  if (typeof session.method !== "string" || !session.method.trim()) {
    throw new Error("Invalid upload session: the upload method is missing");
  }
  if (
    session.headers === null ||
    typeof session.headers !== "object" ||
    Array.isArray(session.headers)
  ) {
    throw new Error("Invalid upload session: the upload headers are missing");
  }
}
